import { createContext, ReactNode, useState, Dispatch, SetStateAction } from 'react'
import {
  FieldValues,
  useFormContext,
  useController,
  UseControllerReturn,
  UseFormTrigger,
  UseFormSetValue,
  UseFormResetField
} from 'react-hook-form'

interface FormFieldContextValue extends UseControllerReturn<FieldValues, string> {
  name: string;
  trigger: UseFormTrigger<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  isFocus: boolean;
  setIsFocus: Dispatch<SetStateAction<boolean>>;
  resetField: UseFormResetField<FieldValues>;
}

export const FormFieldContext = createContext<FormFieldContextValue>({} as FormFieldContextValue)

export const FormField = ({ name, children }: { name: string, children: ReactNode }) => {
  const [isFocus, setIsFocus] = useState(false)

  if (!name) {
    throw new Error('Form Field require name  !!!')
  }

  const { control, trigger, setValue, resetField } = useFormContext()

  const field = useController({
    control: control,
    name
  })

  return (
    <FormFieldContext.Provider
      value={{
        ...field,
        name,
        trigger,
        setValue,
        isFocus: isFocus,
        setIsFocus,
        resetField
      }}
    >
      {children}
    </FormFieldContext.Provider>
  )
}
